module.exports = __webpack_public_path__ + "static/media/back4.c3959fb1.jpg";